// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1_ysy","jump":"styles_jump__xC6lq","pulse":"styles_pulse__ttAwA"};